import { t } from "i18next";
import { SkeletonTheme } from "react-loading-skeleton";
import { EmptyListPlaceholderContent } from "../../shared/Ui/EmptyPageBlock";
import ActionDropwdownCell from "../../shared/components/Table/ActionDropwdownCell";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { orderColumns, PaginationState } from "@tanstack/react-table";
import { useAppSelector } from "../../shared/hook";
import Pagination from "../../shared/components/Table/Pagination";
import StatusBadge from "../../shared/Ui/StatusBadge/StatusBadge";
import { format } from "date-fns";
import { Tooltip } from "react-tooltip";
import { Field, Form, Formik } from "formik";
import style from "../Orders/orders.module.css";
import SelectCustomFormik from "../../shared/Ui/SelectCustom/SelectCustomFormik";
import classNames from "classnames";
import Calendar from "../../shared/Ui/Calendar/Calendar";
import { normalizedLocale } from "../../common/libs/normalizedLocale";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import DocumentUpload from "../upload/DocumentUpload/DocumentUpload";
import QrScannerComponent from "../../shared/components/Qr/QrScannerComponent";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import { log, table } from "node:console";
import { stat } from "node:fs";
import { v4 as uuidv4 } from 'uuid';
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoicePDF from "./utils/sendOrderPdf";
import { addItemsToOrder, deleteOrderItems, getOrderById, getOrderItemsByOrderId, rejectOrder, sendToConfim, reduceOrderItems, returnOrderItems } from "../../common/api/ordersApi";


function Orders() {
    const [errorModal, setErrorModal] = useState(false);
    const [activeTooltipId, setActiveTooltipId] = useState<number | null>(null);
    const handleTooltipToggle = (id: number) => {
        setActiveTooltipId((prevId) => (prevId === id ? null : id));
    };
    const [isReductOpen, setIsReductOpen] = useState<any>(null)
    const [isAddOpen, setIsAddOpen] = useState<any>(null)
    const tableDataCookie = JSON.parse(localStorage.getItem('TableData') || 'null');
    const [status, setStatus] = useState(null);
    const [isScannerOpen, setIsScannerOpen] = useState(false);
    const role = Cookies.get("role");
    const [isFileUploadModalOpen, setIsFileUploadModalOpen] = useState<boolean>(false);
    const { DocumentId } = useParams();
    const [parsedRows, setParsedRows] = useState([])
    const [toggleOnLoad, setToggleOnLoad] = useState<boolean>(false);
    const { t, i18n } = useTranslation();
    const [ntinSelect, setNtinSelect] = useState([])
    const locale = normalizedLocale(i18n.language);
    const [releaseMethods, setReleaseMethods] = useState([]);
    const [sort, setSort] = useState<"ASC" | "DESC">("DESC");
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({ date: "" });
    const [startDate, setStartDate] = useState<Date | undefined>(undefined);
    const [endDate, setEndDate] = useState<Date | undefined>(undefined);
    const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false);
    const [jewelryGroup, setJewelryGroup] = useState<any>([])
    const userData: any = useAppSelector((state) => state.auth.userData);
    const [isDeletOpen, setIsDeletOpen] = useState<any>(null)
    const [dataObject, setDataObject] = useState<any>({
        startDate: undefined, // Начальная дата по умолчанию
        startTime: "", // Время для начальной даты по умолчанию
        endDate: undefined, // Конечная дата по умолчанию
        endTime: "", // Время для конечной даты по умолчанию
    });
    const [tableData, setTableData] = useState<any>({
        "id": 7,
        "status": "",
        "tradePoint": {
            "id": 1,
            "name": "Моя Торговая Точка 1",
            "bin": "251950743077",
            "address": "г. Алматы, ул. Абая, 10",
            "phone": "+7 701 123 4567",
            "email": "example@example.com",
            "disabled": false,
            "hibernateLazyInitializer": {}
        },
        "createdAt": "-",
        "userEmail": "sktl.gg@mail.ru",
        "items": []
    });
    const [isLoading, setIsLoading] = useState(false);
    const pageSize = useAppSelector((state) => state.userSettings.pageSize);
    type PaginationState = {
        pageIndex: number;
        pageSize: number;
    };

    const [pagination, setPagination] = useState<PaginationState>(() => {
        const savedPagination = localStorage.getItem('paginationCheques');
        return { pageIndex: 0, pageSize: pageSize };
    });

    const [editedItems, setEditedItems] = useState<any[]>([]);
    const [deliveryDate, setDeliveryDate] = useState<string>("");
    const [customReason, setCustomReason] = useState<string>("");

    const handleIncrease = (id: number) => {
        if (!isReductOpen || !tableData?.items) return;

        const currentItem = tableData.items.find((item: any) => item.id === id);
        if (!currentItem) return;

        const maxQuantity = currentItem.quantity;

        setIsReductOpen((prev: any) => {
            if (!prev) return null;
            return {
                ...prev,
                quantity: Math.min((prev.quantity || 0) + 1, maxQuantity || 0),
            };
        });
    };

    const handleDecrease = (id: number) => {
        if (!isReductOpen) return;

        setIsReductOpen((prev: any) => {
            if (!prev) return null;

            return {
                ...prev,
                quantity: Math.max((prev.quantity || 0) - 1, 0), // ограничение снизу
            };
        });
    };
    const handleQuantityChange = (id: number, newValue: string) => {
        console.log(isReductOpen);

        // Находим исходный товар
        const originalItem = tableData.items.find((item: any) => item.id === id);
        if (!originalItem) return;

        // Ограничиваем ввод от 0 до исходного количества
        const quantity = Math.max(0, Math.min(Number(newValue), originalItem.quantity));

        setIsReductOpen((prev: any) => ({
            ...prev,
            quantity: quantity,
        }));
    };

    const handleReasonChange = (selectedOption: any) => {
        console.log('Selected option:', selectedOption);
        console.log('Current isReductOpen:', isReductOpen);
        setIsReductOpen((prev: any) => {
            const newState = {
                ...prev,
                [role === "Администратор" ? "editReason" : "returnReason"]: selectedOption?.value === "Другая причина" ? customReason : selectedOption?.value,
                isCustomReason: selectedOption?.value === "Другая причина"
            };
            console.log('New state:', newState);
            return newState;
        });
    };

    useEffect(() => {
        localStorage.setItem('paginationCheques', JSON.stringify(pagination));
    }, [pagination]);
    interface StatusType {
        type: string;
        label: string;
    }
    const isUUID = (id: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(id);
    interface Product {
        id: number;
        name: string;
        barcode: string;
        status: string;
        statusLabel: string;
        adress: string;
        createdAt: string;
        deliveryDate: string;
        data: Product[]; // Подразумевается, что `data` тоже массив объектов типа `Product`
    }


    useEffect(() => {
        if (!DocumentId) return;

        const fetchData = async () => {
            try {
                console.log('Начало загрузки данных заказа');

                const order = await getOrderById(Number(DocumentId));
                console.log('Получен заказ:', order);

                const data = await getOrderItemsByOrderId(Number(DocumentId));
                console.log("Получены товары заказа:", data);

                const newTableData = {
                    ...order,
                    items: data
                };

                setTableData(newTableData);
                setStatus(newTableData.status);
                console.log("Обновленные данные:", newTableData);

            } catch (error) {
                console.error("Ошибка при получении данных заказа:", error);
            }
        };

        fetchData();
    }, [isFileUploadModalOpen, DocumentId, isDeletOpen, pagination]);


    useEffect(() => {
        onLoad()
    }, [pagination]);

    const debounce = (func: Function, delay: number) => {
        let timeoutId: ReturnType<typeof setTimeout>;
        return (...args: any) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    async function onLoad() {

    }

    const handleScanResult = async (result: string) => {

        console.log('initial', initialValues);
        setIsScannerOpen(false);

    };

    const toggleSort = () => {
        const newSortDirection = sort === "ASC" ? "DESC" : "ASC";
        setSort(newSortDirection);
    };

    const calculateItemNumber = (index: any) => {
        return pagination.pageIndex * pagination.pageSize + index + 1;
    };
    const statusTypes: { [key: string]: StatusType } = {
        DRAFT: { type: "test", label: t("Черновик") },
        SENT_TO_CONFIRMATION: {
            type: "test",
            label: t("Ожидает подтверждения"),
        },
        REJECTED: { type: "error", label: t("Отклонен") },
        WAITING_FOR_DELIVERY: { type: "test", label: t("Ожидает доставки") },
        PARTIALLY_DELIVERED: { type: "active", label: t("Частично доставлен") },
        CONFIRMED: { type: "active", label: t("Подтвержден") },
    };

    const renderActions = (
        value: any,
        setErrorModal: any,
        navigate: any,
        setAlertOpen?: any,
        setIsCheckOpen?: any,
    ) => {
        const actions = [];
        actions.push({
            title: t("orderList.show"),
            action: () => {
                if (value.status == 'PROCESSED') {
                    navigate("/cheque/" + value?.id)
                }

            }
        });
        return actions;
    };
    const [initialValues, setInitialValues] = useState({
        fiscalDocumentNumber: "",
        kktRegId: '',
        operationType: null,
        status: null,
        refJewelryGroupId: '',
        ntin: null,
        vendor: ''
    });
    //тут будут запросы для полей фильтров


    const handleUpdateDate = () => {
        console.log('[handleUpdateDate] called, isReductOpen:', isReductOpen);
        if (!isReductOpen) {
            console.log('[handleUpdateDate] Early return: isReductOpen is null');
            return;
        }

        // Находим исходный предмет
        const originalItem = tableData.items.find((item: any) => item.id === isReductOpen.id);
        if (!originalItem) return;

        // Вычисляем разницу между исходным количеством и новым
        const reductCount = originalItem.quantity - isReductOpen.quantity;

        // Обновляем только выбранный предмет в tableData
        setTableData((prev: typeof tableData) => {
            const updated = {
                ...prev,
                items: prev.items.map((item: any) => {
                    if (item.id === isReductOpen.id) {
                        if (role === "Администратор") {
                            return {
                                ...item,
                                quantity: isReductOpen.quantity,
                                // Добавляем новую разницу к существующему reductCount
                                reductCount: (item.reductCount || 0) + reductCount,
                                editReason: isReductOpen.editReason || isReductOpen.returnReason
                            };
                        } else {
                            return {
                                ...item,
                                quantity: isReductOpen.quantity,
                                // Добавляем новую разницу к существующему returnedQuantity
                                returnedQuantity: (item.returnedQuantity || 0) + reductCount,
                                returnReason: isReductOpen.returnReason
                            };
                        }
                    }
                    return item;
                })
            };
            console.log('[handleUpdateDate] setTableData updated:', updated);
            return updated;
        });

        // Добавляем только выбранный предмет в editedItems
        setEditedItems(prev => {
            // Находим существующую запись для этого предмета
            const existingItem = prev.find(e => e.itemId === isReductOpen.id);
            
            // Удаляем предыдущую запись для этого предмета
            const filtered = prev.filter(e => e.itemId !== isReductOpen.id);
            
            // Добавляем новую запись только если есть изменения
            if (reductCount > 0) {
                let newItem;
                if (role === "Администратор") {
                    newItem = {
                        itemId: isReductOpen.id,
                        // Добавляем новую разницу к существующему reductCount
                        reductCount: (existingItem?.reductCount || 0) + reductCount,
                        editReason: isReductOpen.editReason || isReductOpen.returnReason
                    };
                } else {
                    newItem = {
                        itemId: isReductOpen.id,
                        // Добавляем новую разницу к существующему returnedQuantity
                        returnedQuantity: (existingItem?.returnedQuantity || 0) + reductCount,
                        returnReason: isReductOpen.returnReason
                    };
                }
                return [...filtered, newItem];
            }
            
            return filtered;
        });

        setIsReductOpen(null);
        console.log('[handleUpdateDate] setIsReductOpen(null)');
    };

    const handleConfirmChanges = async () => {
        console.log('[handleConfirmChanges] called, editedItems:', editedItems, 'deliveryDate:', deliveryDate);
        if (!DocumentId) return;
        try {
            if (role === "Администратор") {
                const payload = {
                    items: editedItems,
                    deliveryDate: deliveryDate || undefined
                };
                await reduceOrderItems(Number(DocumentId), payload);
            } else if (role === "Пользователь") {
                await returnOrderItems(Number(DocumentId), editedItems);
            }
            // После успешного сохранения обновляем данные
            const order = await getOrderById(Number(DocumentId));
            const data = await getOrderItemsByOrderId(Number(DocumentId));
            setTableData({
                ...order,
                items: data
            });
            setEditedItems([]);
            setDeliveryDate("");
            console.log('Изменения успешно отправлены на сервер');
            navigate("/orders")
        } catch (error) {
            console.error('Ошибка при сохранении изменений на сервере:', error);
        }
    };

    const handleAccept = async () => {
        if (!DocumentId) return;
        try {
            await returnOrderItems(Number(DocumentId), editedItems);
            console.log('Заказ успешно принят');
            navigate("/orders")
        } catch (error) {
            console.error('Ошибка при принятии заказа:', error);
        }
    };

    const handleMiss = async () => {
        try {
            await rejectOrder(Number(DocumentId));
            navigate("/orders");
        } catch (error) {
            console.error("Ошибка при отклонении заказа:", error);
        }
    };


    const handleVozvrat = () => {
        // Получаем текущие данные из куки
        const existingData = JSON.parse(localStorage.getItem('TableData') || 'null');

        let parsedData = existingData ? existingData : [];
        console.log("parsedData", parsedData);

        parsedData = parsedData.map((item: any) =>
            item.id == DocumentId ? { ...item, status: "ERROR", statusLabel: "Возврат" } : item
        );

        localStorage.setItem('TableData', JSON.stringify(parsedData));

        navigate("/orders")

    };


    function filterAndTransformItemsForNewOrder(originalData: any) {
        const filteredValues = originalData.values
            .map((item: any) => {
                const filteredData = item.data
                    .filter(
                        (product: any) =>
                            (product.returnedQuantity && product.returnedQuantity > 0) ||
                            (product.reductCount && product.reductCount > 0)
                    )
                    .map((product: any) => ({
                        ...product,
                        quantity:
                            (product.returnedQuantity || 0) + (product.reductCount || 0),
                        reductCount: 0,
                        returnedQuantity: 0,
                    }));

                if (filteredData.length === 0) return null;

                return {
                    ...item,
                    id: uuidv4(),
                    data: filteredData,
                    status: 'DRAFT',
                    statusLabel: 'Черновик',
                    createdAt: new Date().toISOString().split('T')[0],
                };
            })
            .filter((item: any) => item !== null);

        // Если после фильтрации ничего не осталось — возвращаем null
        if (filteredValues.length === 0) {
            return null;
        }

        return {
            ...originalData,
            values: filteredValues,
        };
    }




    const handleSaveItem = async () => {
        try {
            const payload = {
                items: [{
                    itemId: isReductOpen.id,
                    reductCount: isReductOpen.quantity,
                    editReason: isReductOpen.editReason || isReductOpen.returnReason
                }]
            };

            if (role === "Администратор") {
                await reduceOrderItems(Number(DocumentId), payload);
            } else {
                await returnOrderItems(Number(DocumentId), [{
                    itemId: isReductOpen.id,
                    returnedQuantity: isReductOpen.quantity,
                    returnReason: isReductOpen.returnReason
                }]);
            }

            // Обновляем данные после успешного запроса
            const order = await getOrderById(Number(DocumentId));
            const data = await getOrderItemsByOrderId(Number(DocumentId));

            setTableData({
                ...order,
                items: data
            });

            setIsReductOpen(null);
        } catch (error) {
            console.error("Ошибка при сохранении изменений:", error);
        }
    };
    const handleDeleteProduct = async (productId: number) => {
        try {
            await deleteOrderItems(Number(DocumentId), [productId]);

            // After successful deletion, refresh the order data
            const order = await getOrderById(Number(DocumentId));
            const data = await getOrderItemsByOrderId(Number(DocumentId));

            setTableData({
                ...order,
                items: data
            });
        } catch (error) {
            console.error("Error deleting product:", error);
        }
    };


    return (
        <Formik
            initialValues={formValues}
            onSubmit={(formikValues) => console.log(123)}
            enableReinitialize={true}
            validateOnBlur={true}
            validateOnChange={true}
        //   validationSchema={formValidationSchema}
        >
            {(formik) => (
                < >
                    <ModalComponent
                        isOpen={isDeletOpen}
                        onClose={() => {
                            setIsDeletOpen(null);
                        }}
                        content={
                            <div className="w-[600px] bg-white flex flex-col gap-6">
                                <h2 className="text-xl font-semibold text-gray-900">Удалить заказ</h2>
                                <p className="text-gray-700 text-base">
                                    Вы уверены, что хотите удалить этот заказ? Это действие нельзя будет отменить.
                                </p>

                            </div>
                        }
                        customContent={
                            <div className="flex gap-[15px]">
                                <ModalButton
                                    type="button"
                                    color='grey'
                                    onClick={() => {
                                        console.log(tableData);
                                        setIsDeletOpen(null)
                                    }}
                                >
                                    Закрыть
                                </ModalButton>
                                <ModalButton
                                    type="button"
                                    color='mainColor'
                                    onClick={() => {
                                        console.log("working");

                                        deleteOrderItems(Number(DocumentId), [isDeletOpen])
                                        setIsDeletOpen(null)
                                    }}
                                >
                                    Удалить
                                </ModalButton>
                            </div>

                        }
                    />
                    <ModalComponent
                        isOpen={isReductOpen}
                        onClose={() => {
                            if (isReductOpen) {
                                handleUpdateDate();
                            }
                            setIsReductOpen(null);
                            setCustomReason("");
                        }}
                        content={
                            <div className="flex w-[600px] flex-col gap-[20px]">
                                <span className="font-normal text-[18px]">Редактирование заявки</span>
                                <div className="rounded-lg bg-white overflow-auto">
                                    <table className="max-w-full w-full leading-normal">
                                        <thead className="border-b-2 border-gray-300">
                                            <tr>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                    scope="col"
                                                >
                                                    Наименование товара
                                                </th>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                                    scope="col"
                                                >
                                                    Штрих-код
                                                </th>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                                    scope="col"
                                                >
                                                    Кол-во
                                                </th>


                                            </tr>
                                        </thead>
                                        {isLoading ? (
                                            <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                                                <tbody className="font-normal text-center">

                                                </tbody>
                                            </SkeletonTheme>
                                        ) : tableData?.items.length === 0 || !tableData ? (
                                            <tbody>
                                                <tr>
                                                    <td colSpan={8} className="text-center py-5">
                                                        <div>
                                                            <EmptyListPlaceholderContent
                                                                title={t("Товары не найдены")}
                                                            // description={t("orderList.noOrdersDescription")}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            <tbody className="font-normal text-center">
                                                {tableData?.items.length == 0 && (
                                                    <tr>
                                                        <td colSpan={8} className="text-center py-4">
                                                            <EmptyListPlaceholderContent title={"В этом заказе пока еще нет товаров"} />
                                                        </td>
                                                    </tr>)}

                                                <tr
                                                    className=""
                                                >
                                                    <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600 cursor-pointer "
                                                    >
                                                        {isReductOpen?.name || "-"}
                                                    </td>
                                                    <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                        {isReductOpen?.barcode || "-"}
                                                    </td>

                                                    <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                                                        <div className="flex items-center justify-center ">
                                                            <button
                                                                onClick={() => handleDecrease(isReductOpen.id)}
                                                                className="px-2 py-1 border border-blue-300  text-blue-300 rounded-l-lg hover:bg-blue-100"
                                                            >
                                                                −
                                                            </button>
                                                            <input
                                                                type="number"
                                                                className="w-12 text-center border border-gray-300  h-[30px]"
                                                                value={isReductOpen ? isReductOpen.quantity : ''}
                                                                min={1}
                                                                onChange={(e) => handleQuantityChange(isReductOpen.id, e.target.value)}
                                                            />
                                                            <button
                                                                onClick={() => handleIncrease(isReductOpen.id)}
                                                                className="px-2 py-1 border border-blue-300  text-blue-300 rounded-r-lg hover:bg-blue-100"
                                                            >
                                                                +
                                                            </button>
                                                        </div>
                                                    </td>

                                                </tr>

                                            </tbody>
                                        )}
                                    </table>

                                </div>
                                <div className={style.inputField2}>
                                    <div className={style.labelAndButtonWrapper}>
                                        <label className={style.inputLabel2}>
                                            Причина редактирования
                                        </label>
                                    </div>
                                    <div className="relative flex flex-col gap-2">
                                        <Field
                                            component={SelectCustomFormik}
                                            name="editReason"
                                            placeholder="Введите причину"
                                            className="placeholder"
                                            onChange={(option: any) => {
                                                console.log('Select onChange:', option);
                                                if (option === "Другая причина") {
                                                    setCustomReason("");
                                                    setIsReductOpen((prev: any) => ({
                                                        ...prev,
                                                        isCustomReason: true
                                                    }));
                                                    
                                                } else {
                                                    setIsReductOpen((prev: any) => ({
                                                        ...prev,
                                                        isCustomReason: false,
                                                        [role === "Администратор" ? "editReason" : "returnReason"]: option?.value
                                                    }));
                                                }
                                            }}
                                            value={isReductOpen?.editReason || isReductOpen?.returnReason || null}
                                            options={[
                                                { value: "Поврежденный товар", label: "Поврежденный товар" },
                                                { value: "Неверный товар", label: "Неверный товар" },
                                                { value: "Истекший срок годности", label: "Истекший срок годности" },
                                                { value: "Другая причина", label: "Другая причина" }
                                            ]}
                                        />
                                        {isReductOpen?.isCustomReason && (
                                            <div className="flex flex-col gap-2">
                                                <label className={style.inputLabel2}>
                                                    Укажите причину
                                                </label>
                                                <textarea
                                                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    placeholder="Введите вашу причину"
                                                    value={customReason}
                                                    onChange={(e) => {
                                                        setCustomReason(e.target.value);
                                                        setIsReductOpen((prev: any) => ({
                                                            ...prev,
                                                            [role === "Администратор" ? "editReason" : "returnReason"]: e.target.value
                                                        }));
                                                    }}
                                                    rows={3}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        }
                        customContent={
                            <div className="flex gap-[15px]">
                                <ModalButton
                                    type="button"
                                    color='grey'
                                    onClick={() => {
                                        setIsReductOpen(null);
                                        formik.resetForm(); // Сбрасываем форму
                                    }}
                                >
                                    Закрыть
                                </ModalButton>
                                <ModalButton
                                    type="button"
                                    color='mainColor'
                                    onClick={() => {
                                        console.log('[ModalButton] Сохранить click, isReductOpen:', isReductOpen);
                                        handleUpdateDate();
                                        formik.resetForm(); // Сбрасываем форму
                                    }}
                                >
                                    Сохранить
                                </ModalButton>
                            </div>
                        }
                    />



                    <ModalComponent
                        isOpen={isAddOpen}
                        onClose={() => {
                            setIsAddOpen(null);
                        }}
                        content={
                            <div className="flex w-[600px] flex-col gap-[20px]">
                                <span className="font-normal text-[18px]">создание новой заявки</span>
                                <div className="rounded-lg bg-white overflow-auto">
                                    <table className="max-w-full w-full leading-normal">
                                        <thead className="border-b-2 border-gray-300">
                                            <tr>

                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                    scope="col"
                                                >
                                                    Наименование товара
                                                </th>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                                    scope="col"
                                                >
                                                    Штрих-код
                                                </th>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                                    scope="col"
                                                >
                                                    Кол-во
                                                </th>


                                            </tr>
                                        </thead>
                                        {isLoading ? (
                                            <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                                                <tbody className="font-normal text-center">

                                                </tbody>
                                            </SkeletonTheme>
                                        ) : isAddOpen?.items.length === 0 || !isAddOpen?.items ? (
                                            <tbody>
                                                <tr>
                                                    <td colSpan={8} className="text-center py-5">
                                                        <div>
                                                            <EmptyListPlaceholderContent
                                                                title={t("Товары не найдены")}
                                                            // description={t("orderList.noOrdersDescription")}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            <tbody className="font-normal text-center">
                                                {/* Если товаров нет — показываем плейсхолдер */}
                                                {isAddOpen?.items.length === 0 && (
                                                    <tr>
                                                        <td colSpan={8} className="text-center py-4">
                                                            <EmptyListPlaceholderContent title="В этом заказе пока еще нет товаров" />
                                                        </td>
                                                    </tr>
                                                )}

                                                {/* Мап товаров */}
                                                {isAddOpen?.values?.[0]?.data?.map((product: any) => (
                                                    <tr key={product.id}>
                                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 cursor-pointer">
                                                            {product.name || "-"}
                                                        </td>

                                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                            {product.barcode || "-"}
                                                        </td>

                                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                                                            <div className="flex items-center justify-center">
                                                                {/* <button
                                                                    onClick={() => handleDecrease(product.id)}
                                                                    className="px-2 py-1 border border-blue-300 text-blue-300 rounded-l-lg hover:bg-blue-100"
                                                                >
                                                                    −
                                                                </button> */}
                                                                {
                                                                    product.quantity
                                                                }
                                                                {/* <input
                                                                    type="number"
                                                                    className="w-12 text-center border border-gray-300 h-[30px]"
                                                                    value={product.quantity}
                                                                    min={1}
                                                                    onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                                                                /> */}
                                                                {/* <button
                                                                    onClick={() => handleIncrease(product.id)}
                                                                    className="px-2 py-1 border border-blue-300 text-blue-300 rounded-r-lg hover:bg-blue-100"
                                                                >
                                                                    +
                                                                </button> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        )}
                                    </table>

                                </div>

                            </div>
                        }
                        customContent={
                            <div className="flex gap-[15px]">
                                <ModalButton
                                    type="button"
                                    color='grey'
                                    onClick={() => {
                                        const existingData = JSON.parse(localStorage.getItem('TableData') || 'null');

                                        let parsedData = existingData ? existingData : [];
                                        // console.log("parsedData", parsedData);


                                        parsedData = parsedData.map((item: any) =>
                                            item.id == DocumentId ? { ...item, status: "PROCESSED", statusLabel: "Доставлено (частично)", data: tableData.values[0].data } : item
                                        )
                                        localStorage.setItem('TableData', JSON.stringify(parsedData));
                                        console.log('parsedData', parsedData);
                                        navigate("/orders")
                                    }}
                                >
                                    Отказаться
                                </ModalButton>
                                <ModalButton
                                    type="button"
                                    color='mainColor'
                                    onClick={() => {
                                        const existingData = JSON.parse(localStorage.getItem('TableData') || 'null');

                                        let parsedData = existingData ? existingData : [];
                                        console.log("parsedData", parsedData);

                                        parsedData = parsedData.map((item: any) =>
                                            item.id == DocumentId ? { ...item, status: "PROCESSED", statusLabel: "Доставлено (частично)", data: tableData.values[0].data } : item
                                        )

                                        localStorage.setItem('TableData', JSON.stringify(parsedData));

                                        console.log(parsedData);

                                        console.log(isAddOpen.values[0]);
                                        const updatedData = [isAddOpen.values[0], ...parsedData];

                                        localStorage.setItem('TableData', JSON.stringify(updatedData));
                                        navigate("/orders")
                                    }}
                                >
                                    Создать
                                </ModalButton>
                            </div>

                        }
                    />
                    <div className="flex flex-col w-[100%]">

                        <div className="flex flex-col w-full">
                            <span className="my-3 text-xl font-semibold">
                                {!status || status == "DRAFT" ? "Добавление заказа" : "Просмотр заказа"}
                            </span>

                            {/* Order Information Section */}
                            <div className="bg-white p-6 rounded-xl shadow-md mb-5">
                                <div className="grid grid-cols-3 gap-6">
                                    <div className="space-y-4">
                                        <div>
                                            <h3 className="text-sm font-medium text-gray-500">Статус заказа</h3>
                                            <div className="mt-1">
                                                <StatusBadge
                                                    type={status && statusTypes[status]?.type || "unsaved"}
                                                    fontSize="16px"
                                                    circleSize="8px"
                                                >
                                                    {status && statusTypes[status]?.label || t("documents_upload.unknownStatus")}
                                                </StatusBadge>
                                            </div>
                                        </div>
                                        <div>
                                            <h3 className="text-sm font-medium text-gray-500">Номер заказа</h3>
                                            <p className="mt-1 text-gray-900">{tableData?.id || '-'}</p>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <h3 className="text-sm font-medium text-gray-500">Дата и время создания</h3>
                                            <p className="mt-1 text-gray-900">
                                                {tableData?.createdAt && !isNaN(new Date(tableData.createdAt).getTime())
                                                    ? format(new Date(tableData.createdAt), "dd.MM.yyyy HH:mm:ss")
                                                    : '-'}
                                            </p>
                                        </div>
                                        <div>
                                            <h3 className="text-sm font-medium text-gray-500">Торговая точка</h3>
                                            <p className="mt-1 text-gray-900">{tableData?.tradePoint?.name || '-'}</p>
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <div>
                                            <h3 className="text-sm font-medium text-gray-500">Email пользователя</h3>
                                            <p className="mt-1 text-gray-900">{tableData?.userEmail || '-'}</p>
                                        </div>
                                        <div>
                                            <h3 className="text-sm font-medium text-gray-500">Количество товаров</h3>
                                            <p className="mt-1 text-gray-900">{tableData?.items?.length || 0}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {((status !== "PARTIALLY_DELIVERED" && status !== "CONFIRMED" && status !== "REJECTED") && !(status === "SENT_TO_CONFIRMATION" && role === "Пользователь")) && (
                                <div className="bg-white  my-5 p-5 relative rounded-xl shadow-md">
                                    <div className="flex flex-row align-center justify-between">
                                        <div className="flex flex-row gap-[20px] items-end">
                                            {role == "Администратор" &&
                                                (status == 'WAITING_FOR_DELIVERY' || status == 'CONFIRMED' || status == 'PARTIALLY_DELIVERED') && (
                                                    <div className="flex gap-[20px]">
                                                        <PDFDownloadLink
                                                            document={<InvoicePDF data={tableData} />}
                                                            fileName="nakladnaya.pdf"
                                                        >
                                                            {({ loading }) => (
                                                                <button className="buttonMain bg-mainColor w-[333px] text-gray-700 font-semibold py-2 px-4 rounded">
                                                                    {loading ? "Генерация..." : "Выгрузить накладную PDF"}
                                                                </button>
                                                            )}
                                                        </PDFDownloadLink>
                                                    </div>
                                                )}
                                            {role == "Пользователь" && status === 'WAITING_FOR_DELIVERY' ? (
                                                <button
                                                    onClick={() => handleVozvrat()}
                                                    // onClick={() => console.log(tableData)}
                                                    className="buttonMain bg-slate-200 w-[150px] text-gray-600  font-semibold py-2 px-4 rounded max-h-[40px] hover:bg-mainColor"
                                                >
                                                    Возврат
                                                </button>
                                            ) : role === "Администратор" && status === "SENT_TO_CONFIRMATION" ? (
                                                <button
                                                    onClick={() => handleMiss()}
                                                    className="buttonMain bg-gray-300 w-[150px] text-gray-700  font-semibold py-2 px-4 rounded max-h-[40px]"
                                                >
                                                    Отклонить
                                                </button>
                                            ) : null}
                                        </div>

                                        {role != "Администратор" && (!tableData?.status || tableData?.status == "DRAFT") ? (
                                            <div className="flex gap-[20px]">
                                                <button
                                                    onClick={() => {
                                                        setIsFileUploadModalOpen(true);
                                                    }}
                                                    className="buttonMain bg-mainColor w-[150px] text-gray-700  font-semibold py-2 px-4 rounded"
                                                >
                                                    Загрузить
                                                </button>
                                                <button
                                                    onClick={() => {
                                                        navigate(`/order/catalog/${DocumentId}`);
                                                    }}
                                                    className="buttonMain bg-mainColor w-[150px] text-gray-700  font-semibold py-2 px-4 rounded"
                                                >
                                                    Каталог
                                                </button>
                                                {DocumentId && tableData.status == "DRAFT" && (
                                                    <button
                                                        onClick={() => {
                                                            sendToConfim(Number(DocumentId));
                                                            navigate('/orders');
                                                        }}
                                                        className="buttonMain bg-mainColor w-[150px] text-gray-700  font-semibold py-2 px-4 rounded"
                                                    >
                                                        Сохранить
                                                    </button>
                                                )}



                                            </div>

                                        ) :
                                            (
                                                <div >

                                                    {(status == "SENT_TO_CONFIRMATION" && role == "Администратор") ? (
                                                        <div className="flex max-h-[60px] items-end gap-[15px]">
                                                            {status == "SENT_TO_CONFIRMATION" && (
                                                                <div className={style.inputField}>
                                                                    <div className={style.labelAndButtonWrapper}>
                                                                        <label className={style.inputLabel2}>
                                                                            Дата поставки
                                                                        </label>
                                                                    </div>
                                                                    <input
                                                                        type="date"
                                                                        value={deliveryDate}
                                                                        onChange={e => setDeliveryDate(e.target.value)}
                                                                        className="border rounded px-2 py-1"
                                                                    />
                                                                </div>
                                                            )}

                                                            <button
                                                                onClick={handleConfirmChanges}
                                                                className="buttonMain bg-mainColor w-[150px] text-gray-700  font-semibold py-2 px-4 rounded max-h-[40px]"
                                                            >
                                                                Подтвердить
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div></div>
                                                    )
                                                    }
                                                  

                                                    {role == "Пользователь" && status == 'WAITING_FOR_DELIVERY' && (
                                                        <div className="flex gap-[20px]">
                                                            <button
                                                                key="meni-item-logout"
                                                                className="w-[150px] group flex rounded-md p-2 cursor-pointer  text-gray-700  font-semibold items-center gap-x-4 py-2 px-4 bg-slate-200
                                                        hover:bg-mainColor hover:text-gray-700"
                                                                onClick={() => {
                                                                    setIsScannerOpen(true);
                                                                }}
                                                            >
                                                                <img
                                                                    src={`/icons/scaner.svg`}
                                                                    className="block h-6 w-6 duration-200  group-hover:invert-1"
                                                                />
                                                                <span className={`${!open && "hidden"} origin-left duration-200`}>
                                                                    Сканер
                                                                </span>
                                                            </button>
                                                            <button
                                                                onClick={handleAccept}
                                                                className="buttonMain bg-mainColor w-[150px] text-gray-700  font-semibold py-2 px-4 rounded"
                                                            >
                                                                Принять
                                                            </button>
                                                            {isScannerOpen && (
                                                                <div className={style.scannerOverlay}>
                                                                    <QrScannerComponent
                                                                        onClose={() => {
                                                                            setIsScannerOpen(false); // Закрываем сканер
                                                                        }}
                                                                        onScanResult={handleScanResult} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                </div>

                                            )
                                        }
                                    </div>

                                </div>
                            )}






                            {/* <div className="flex flex-row gap-[20px]">
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsFilterOpen(true);
                                }}
                                className=" bg-green text-white font-semibold py-2 px-4 rounded"
                                data-tooltip-offset={4}
                                data-tooltip-id="filter-type"
                            >
                                {t("mainButtons3.filter")}
                            </button>
                            <button
                                onClick={() => {
                                    setStartDate(undefined);
                                    setEndDate(undefined);
                                    setInitialValues({
                                        fiscalDocumentNumber: '',
                                        kktRegId: '',
                                        operationType: null,
                                        status: null,
                                        refJewelryGroupId: '',
                                        ntin: null,
                                        vendor: ''
                                    })
                                    setPagination((prevValues: PaginationState) => {
                                        return { ...prevValues, pageIndex: 0 };
                                    });
                                }}
                            >
                                <img src="/icons/update.svg" />
                            </button>
                        </div> */}

                            <div className="w-full">
                                <div className="rounded-lg bg-white overflow-auto">
                                    <table className="max-w-full w-full leading-normal">
                                        <thead className="border-b-2 border-gray-300">
                                            <tr>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                    scope="col"
                                                >
                                                    №
                                                </th>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200"
                                                    scope="col"
                                                >
                                                    Наименование товара
                                                </th>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                                    scope="col"
                                                >
                                                    Штрих-код
                                                </th>
                                                <th
                                                    className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200 "
                                                    scope="col"
                                                >
                                                    Кол-во
                                                </th>
                                                {tableData?.items?.some((item: any) => item.reductCount) && (
                                                    <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200" scope="col">
                                                        Отредактировано
                                                    </th>
                                                )}

                                                {tableData?.items?.some((item: any) => item.returnedQuantity) && (
                                                    <th className="px-5 py-3 text-center text-gray-600 font-semibold bg-white border-b border-gray-200" scope="col">
                                                        Возврат
                                                    </th>
                                                )}

                                            </tr>
                                        </thead>
                                        {isLoading ? (
                                            <SkeletonTheme baseColor="#ebebeb" highlightColor="#c9c9c9">
                                                <tbody className="font-normal text-center">
                                                </tbody>
                                            </SkeletonTheme>
                                        ) : tableData?.items?.length === 0 || !tableData?.items ? (
                                            <tbody>
                                                <tr>
                                                    <td colSpan={8} className="text-center py-5">
                                                        <div>
                                                            <EmptyListPlaceholderContent
                                                                title={t("Товары не найдены")
                                                                }
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) : (
                                            <tbody className="font-normal text-center">
                                                {tableData?.items?.length == 0 && (
                                                    <tr>
                                                        <td colSpan={8} className="text-center py-4">
                                                            <EmptyListPlaceholderContent title={"В этом заказе пока еще нет товаров"} />
                                                        </td>
                                                    </tr>)}
                                                {tableData?.items?.map((value: any, index: any) => (
                                                    <tr
                                                        key={`tr-${index}-${value.id}`}
                                                        className=""
                                                    // onClick={() => {
                                                    //     navigate("/cheque/" + value?.id)
                                                    // }
                                                    // }

                                                    >
                                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                            {calculateItemNumber(index) || "-"}
                                                        </td>
                                                        <td className="px-5 py-5 text-sm  border-b border-gray-200 text-gray-600 cursor-pointer "
                                                        >
                                                            {value?.name || "-"}
                                                        </td>
                                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600">
                                                            {value?.barcode || "-"}
                                                        </td>
                                                        <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                            {/* {format(value?.dateTime, "dd.MM.yyyy") || '-'} */}
                                                            {value.quantity || 0}
                                                        </td>
                                                        {value.reductCount ? (
                                                            // <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                            //     {value.reductCount || ''}
                                                            // </td>
                                                            <td
                                                                className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center max-w-[140px] text-nowrap"
                                                                data-tooltip-id="my-tooltip"
                                                                data-tooltip-content={
                                                                    value.editReason || ''
                                                                }
                                                            >
                                                                {value?.reductCount || "-"}
                                                                <Tooltip id="my-tooltip" place="top" delayHide={100} />
                                                            </td>
                                                        ) : tableData?.items?.some((item: any) => item.reductCount) && (
                                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]"></td>
                                                        )
                                                        }

                                                        {value.returnedQuantity ? (
                                                            // <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                            //     {value.returnedQuantity || ''}
                                                            // </td>
                                                            <td
                                                                className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center max-w-[140px] text-nowrap"
                                                                data-tooltip-id="my-tooltip"
                                                                data-tooltip-content={
                                                                    value.returnReason || ''
                                                                }
                                                            >
                                                                {value?.returnedQuantity || "-"}
                                                                <Tooltip id="my-tooltip" place="top" delayHide={100} />
                                                            </td>
                                                        ) : tableData?.items?.some((item: any) => item.returnedQuantity) && (
                                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]"></td>
                                                        )
                                                        }

                                                        {((role == "Администратор" && status == "SENT_TO_CONFIRMATION") || (role != "Администратор" && status == "WAITING_FOR_DELIVERY")) && (
                                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                                <button
                                                                    onClick={() => setIsReductOpen(value)}
                                                                    className="buttonMain bg-mainColor w-[150px] text-gray-700  font-semibold py-2 px-4 rounded"
                                                                >
                                                                    {role == "Администратор" ? "Редактировать" : "Возврат"}

                                                                </button>
                                                            </td>
                                                        )}
                                                        {status == 'DRAFT' && role == "Пользователь" && (
                                                            <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center w-[225px]">
                                                                <div
                                                                    className="cursor-pointer flex justify-end"
                                                                    onClick={() => handleDeleteProduct(value.id)}
                                                                >
                                                                    <img
                                                                        src="/icons/trash.svg"
                                                                        alt="Delete"
                                                                        className="max-"
                                                                    ></img>
                                                                </div>
                                                            </td>
                                                        )}



                                                        {/* <td className="px-5 py-5 text-sm border-b border-gray-200 text-gray-600 text-center">
                                                            <div className="flex justify-center">
                                                                <StatusBadge
                                                                    // type={statusTypes[value.status]?.type || "unsaved"}
                                                                    fontSize="15px"
                                                                    circleSize="8px"
                                                                >
                                                                    {value.status ||
                                                                        t("documents_upload.unknownStatus")}
                                                                </StatusBadge>
                                                            </div>

                                                        </td> */}

                                                    </tr>
                                                ))}
                                            </tbody>
                                        )}
                                    </table>
                                </div>
                                <Pagination
                                    totalItems={tableData?.count || 0}
                                    totalPages={tableData?.numberOfPages || 0}
                                    pagination={pagination}
                                    setPagination={setPagination}
                                />
                            </div>
                            <div className="z-[1000] relative	">
                                {/* <Tooltip
                            isOpen={isFilterOpen}
                            id="filter-type"
                            className={classNames(style.wrapperTooltipFilter, "drop-shadow-2xl")}
                            openOnClick={true}
                            clickable={true}
                            noArrow={true}
                            opacity={1}
                            place={"bottom-end"}
                            afterShow={() => setIsFilterOpen(true)}
                            afterHide={() => setIsFilterOpen(false)}
                        >
                            <div onClick={(e) => e.stopPropagation()}>{renderFilterInputs()}</div>
                        </Tooltip> */}
                            </div>

                        </div>

                    </div>
                    <DocumentUpload
                        isOpen={isFileUploadModalOpen}
                        setIsOpen={setIsFileUploadModalOpen}
                        documentId={DocumentId}
                        toggleOnLoad={toggleOnLoad}
                        setToggleOnLoad={setToggleOnLoad}
                    />
                </>
            )}
        </Formik >
    );
}


export default Orders;
